import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import RoleAssignmentName from "../../components/roleAssignment/RoleAssignmentDetail/RoleAssignmentName.tsx";
import {useLocationFormState} from "../../components/roleAssignment/RoleAssignmentForm/RoleAssignmentUpdateForm";
import RoleAssignmentUpdateFormProvider from "../../components/roleAssignment/RoleAssignmentForm/RoleAssignmentUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RoleAssignmentUpdateEditPage = () => {
    
    useTitle(t`Update Role Assignment`);

    const { roleAssignmentId: id } = useParams();
    
    return (
        <Box data-testid="RoleAssignment-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="RoleAssignment-update-title"
                    >
                        <Trans>Edit Role Assignment</Trans>:  <RoleAssignmentName id={id}/>
                    </Typography>
                    <RoleAssignmentUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default RoleAssignmentUpdateEditPage;
